import pointAdjustments from "../../api/pointAdjustments";

/**
 * Module Vuex pour la gestion des ajustements de points
 */
export default {
  namespaced: true,
  state: {
    history: [],
    validationResult: null,
    loading: false,
    error: null,
  },
  mutations: {
    /**
     * Définit l'historique des ajustements
     */
    setHistory(state, history) {
      state.history = history;
    },
    /**
     * Définit le résultat de la validation
     */
    setValidationResult(state, validationResult) {
      state.validationResult = validationResult;
    },
    /**
     * Réinitialise le résultat de validation
     */
    clearValidationResult(state) {
      state.validationResult = null;
    },
    /**
     * Définit l'état de chargement
     */
    setLoading(state, loading) {
      state.loading = loading;
    },
    /**
     * Définit une erreur
     */
    setError(state, error) {
      state.error = error;
    },
    /**
     * Réinitialise l'erreur
     */
    clearError(state) {
      state.error = null;
    },
  },
  actions: {
    /**
     * Valide un ajustement de points avant de l'appliquer
     */
    async validatePointAdjustment({ commit }, adjustmentData) {
      commit("setLoading", true);
      commit("clearError");
      try {
        const response = await pointAdjustments.validatePointAdjustment(
          adjustmentData
        );
        commit("setValidationResult", response.data);
        return response.data;
      } catch (error) {
        commit(
          "setError",
          error.response?.data?.message || "Erreur lors de la validation"
        );
        throw error;
      } finally {
        commit("setLoading", false);
      }
    },

    /**
     * Applique un ajustement de points
     */
    async updatePoints({ commit, dispatch }, adjustmentData) {
      commit("setLoading", true);
      commit("clearError");
      try {
        const response = await pointAdjustments.updatePoints(adjustmentData);
        commit("clearValidationResult");
        // Rafraîchir l'historique après un ajustement réussi
        await dispatch("fetchHistory");
        return response.data;
      } catch (error) {
        commit(
          "setError",
          error.response?.data?.message || "Erreur lors de l'ajustement"
        );
        throw error;
      } finally {
        commit("setLoading", false);
      }
    },

    /**
     * Récupère l'historique des ajustements
     */
    async fetchHistory({ commit }, customerId = null) {
      commit("setLoading", true);
      commit("clearError");
      try {
        const response = await pointAdjustments.getPointAdjustmentHistory(
          customerId
        );
        commit("setHistory", response.data);
        return response.data;
      } catch (error) {
        commit(
          "setError",
          error.response?.data?.message ||
            "Erreur lors de la récupération de l'historique"
        );
        throw error;
      } finally {
        commit("setLoading", false);
      }
    },

    /**
     * Réinitialise l'état du module
     */
    resetState({ commit }) {
      commit("clearValidationResult");
      commit("clearError");
      commit("setHistory", []);
    },
  },
  getters: {
    /**
     * Retourne l'historique des ajustements
     */
    history: (state) => state.history,

    /**
     * Retourne le résultat de la validation en cours
     */
    validationResult: (state) => state.validationResult,

    /**
     * Retourne l'état de chargement
     */
    loading: (state) => state.loading,

    /**
     * Retourne l'erreur en cours
     */
    error: (state) => state.error,

    /**
     * Vérifie si une validation est en cours
     */
    hasValidation: (state) => state.validationResult !== null,
  },
};
